import type { FC, HTMLAttributes, ReactNode } from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { cva, type VariantProps } from "class-variance-authority";
import { CircleCheckBigIcon } from "@/components/icons";
import { cn } from "@/lib/cn";

const alertVariants = cva("flex items-center gap-12 rounded-[8px] p-16 shadow-[0px_4px_5px_rgba(0,0,0,0.05)]", {
  variants: {
    type: {
      general: "bg-brand-dark-blue text-neutral-white",
      error: "bg-warning-bg text-brand-red",
    },
  },
  defaultVariants: {
    type: "general",
  },
});

type AlertProps = HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof alertVariants> & {
    icon?: boolean;
    children?: ReactNode;
  };

export const Alert: FC<AlertProps> = ({ className, type = "general", icon = true, children, ...props }) => (
  <div className={cn(alertVariants({ type }), className)} {...props}>
    <p className="text-16 flex-1">{children}</p>
    {icon && type === "general" && <CircleCheckBigIcon className="size-24 shrink-0" />}
    {icon && type === "error" && <ExclamationTriangleIcon className="size-24 shrink-0" />}
  </div>
);
